if($('#loan-calculator').length) {

    let loanCalculatorForm = $('#loan-calculator'),
        price = loanCalculatorForm.find('#price'),
        tradeInValue = loanCalculatorForm.find('#trade-in-value'),
        downPayment = loanCalculatorForm.find('#down-payment'),
        interestRate = loanCalculatorForm.find('#apr'),
        termLength = loanCalculatorForm.find('#term_length'),
        termOptions = loanCalculatorForm.find('.term-option'),
        monthlyPaymentOutput = loanCalculatorForm.find('#monthly-payment-value'),
        totalLoanAmountOutput = loanCalculatorForm.find('#total-loan-amount-value');

    price.on('input', calculateLoan);
    tradeInValue.on('input', calculateLoan);
    downPayment.on('input', calculateLoan);
    interestRate.on('input', calculateLoan);
    termLength.on('change', calculateLoan);

    termOptions.on('click', function() {
        termOptions.removeClass('active');
        $(this).addClass('active');
        termLength.val($(this).data('term'));
        calculateLoan();
    });

    function calculateLoan() {

        let priceValue = parseFloat(price.val() || 0),
            tradeInValueValue = parseFloat(tradeInValue.val() || 0),
            downPaymentValue = parseFloat(downPayment.val() || 0),
            interestRateValue = parseFloat(interestRate.val() || 0),
            termLengthValue = parseInt(termLength.val() || 0);

        let principal = priceValue - tradeInValueValue - downPaymentValue,
            monthlyInterestRate = interestRateValue / 100 / 12,
            numberOfPayments = termLengthValue;

        if(isNaN(principal) || isNaN(monthlyInterestRate) || isNaN(numberOfPayments) || principal <= 0 || monthlyInterestRate < 0 || numberOfPayments <= 0) {
            monthlyPaymentOutput.text('Invalid input');
            totalLoanAmountOutput.text('Invalid input');
            return;
        }

        let monthlyPayment, totalLoanAmount;

        let totalInterest = principal * monthlyInterestRate * numberOfPayments;

        console.log(`Principal: ${principal}, Monthly Interest Rate: ${monthlyInterestRate}, Number of Payments: ${numberOfPayments}, Total Interest: ${totalInterest}`);

        if(monthlyInterestRate === 0) {
            monthlyPayment = principal / numberOfPayments;
            totalLoanAmount = principal;
        } else {
            monthlyPayment = (principal * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -numberOfPayments));
            totalLoanAmount = monthlyPayment * numberOfPayments;
        }



        // console.log(`Input Values - Price: ${priceValue}, Trade-In Value: ${tradeInValueValue}, Down Payment: ${downPaymentValue}, Interest Rate: ${interestRateValue}, Term Length: ${termLengthValue}`);
        //
        // let principal = parseFloat(price.val() || 0) - parseFloat(tradeInValue.val() || 0) - parseFloat(downPayment.val() || 0),
        //     monthlyInterestRate = parseFloat(interestRate.val() || 0) / 100 / 12,
        //     numberOfPayments = parseInt(termLength.val() || 0) * 12;
        //
        // if (isNaN(principal) || isNaN(monthlyInterestRate) || isNaN(numberOfPayments) || principal <= 0 || monthlyInterestRate < 0 || numberOfPayments <= 0) {
        //     monthlyPaymentOutput.text('Invalid input');
        //     totalLoanAmountOutput.text('Invalid input');
        //     return;
        // }
        //
        // console.log(`Principal: ${principal}, Monthly Interest Rate: ${monthlyInterestRate}, Number of Payments: ${numberOfPayments}`);
        //
        // let monthlyPayment, totalLoanAmount;
        //
        // if(monthlyInterestRate === 0) {
        //     monthlyPayment = principal / numberOfPayments;
        //     totalLoanAmount = principal;
        // } else {
        //     monthlyPayment = (principal * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -numberOfPayments));
        //     totalLoanAmount = monthlyPayment * numberOfPayments;
        // }

        // Format outputs as currency with commas
        monthlyPayment = isFinite(monthlyPayment) ? monthlyPayment : 0;
        totalLoanAmount = isFinite(totalLoanAmount) ? totalLoanAmount : 0;
        monthlyPaymentOutput.text('$' + monthlyPayment.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
        totalLoanAmountOutput.text('$' + totalLoanAmount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }));

        if(!$('.calculated-values-container').hasClass('active')) {
            $('.calculated-values-container').slideDown().addClass('active');
        }

    }

    calculateLoan();

}
